module.exports = __webpack_public_path__ + "static/media/CaigoyCreationsSite.eae8a2ae.JPG";